const translations = {
  // ═══════════════════════════════════════
  // GOOGLE REVIEWS BOX
  // ═══════════════════════════════════════
  "reviews.eyebrow": {
    it: "Recensioni verificate", en: "Verified reviews", fr: "Avis vérifiés", de: "Verifizierte Bewertungen", es: "Reseñas verificadas"
  },
  "reviews.outof": {
    it: "su 5", en: "out of 5", fr: "sur 5", de: "von 5", es: "de 5"
  },
  "reviews.count": {
    it: "recensioni", en: "reviews", fr: "avis", de: "Bewertungen", es: "reseñas"
  },
  "reviews.updated": {
    it: "Aggiornato il", en: "Updated on", fr: "Mis à jour le", de: "Aktualisiert am", es: "Actualizado el"
  },
  "reviews.readmore": {
    it: "leggi tutto", en: "read more", fr: "lire plus", de: "mehr lesen", es: "leer más"
  },
  "reviews.readless": {
    it: "mostra meno", en: "show less", fr: "réduire", de: "weniger", es: "mostrar menos"
  },
  "reviews.seeall": {
    it: "Vedi tutte su Google", en: "See all on Google", fr: "Voir tout sur Google", de: "Alle auf Google ansehen", es: "Ver todas en Google"
  },
  // ═══════════════════════════════════════
  // CITY GUIDE (Scopri la zona — sezione AI)
  // ═══════════════════════════════════════
  "cityguide.eyebrow": {    it: "Scopri la zona", en: "Discover the area", fr: "Découvrez la zone", de: "Entdecke die Gegend", es: "Descubre la zona"
  },
  "cityguide.title": {
    it: "Perché visitare", en: "Why visit", fr: "Pourquoi visiter", de: "Warum besuchen", es: "Por qué visitar"
  },
  "cityguide.subtitle": {
    it: "Le 10 cose che devi sapere", en: "The 10 things you should know", fr: "Les 10 choses à savoir", de: "Die 10 Dinge, die du wissen musst", es: "Las 10 cosas que debes saber"
  },
  "cityguide.faq_title": {
    it: "Domande frequenti su", en: "Frequently asked questions about", fr: "Questions fréquentes sur", de: "Häufige Fragen zu", es: "Preguntas frecuentes sobre"
  },
  "cityguide.ai_note": {
    it: "Guida generata con AI · Hostland", en: "AI-generated guide · Hostland", fr: "Guide généré par IA · Hostland", de: "KI-generierter Guide · Hostland", es: "Guía generada con IA · Hostland"
  },
  // ═══════════════════════════════════════
  // LANDING PAGE (Marketing)
  // ═══════════════════════════════════════
  "hero.badge": {
    it: "Inizia a volare",
    en: "Start flying",
    fr: "Commencez à voler",
    de: "Fang an zu fliegen",
    es: "Empieza a volar"
  },
  "hero.title": {
    it: "La tua struttura, il tuo brand.",
    en: "Your property, your brand.",
    fr: "Votre propriété, votre marque.",
    de: "Ihre Unterkunft, Ihre Marke.",
    es: "Tu propiedad, tu marca."
  },
  "hero.subtitle": {
    it: "Hostland ti permette di creare landing page professionali, gestire recensioni, fidelizzare ospiti e far crescere il tuo business — tutto in un unico posto.",
    en: "Hostland lets you create professional landing pages, manage reviews, build guest loyalty and grow your business — all in one place.",
    fr: "Hostland vous permet de créer des pages d'atterrissage professionnelles, gérer les avis, fidéliser les clients et développer votre activité — tout en un seul endroit.",
    de: "Mit Hostland erstellen Sie professionelle Landingpages, verwalten Bewertungen, binden Gäste und lassen Ihr Geschäft wachsen — alles an einem Ort.",
    es: "Hostland te permite crear páginas de aterrizaje profesionales, gestionar reseñas, fidelizar huéspedes y hacer crecer tu negocio — todo en un solo lugar."
  },
  "hero.cta": {
    it: "Inizia ora, 30 giorni sono gratis (1 mese)",
    en: "Start now, 30 days free",
    fr: "Commencez maintenant, 3 jours gratuits",
    de: "Jetzt starten, 3 Tage kostenlos",
    es: "Empieza ahora, 3 días gratis"
  },
  "hero.already_account": {
    it: "Hai già un account?",
    en: "Already have an account?",
    fr: "Vous avez déjà un compte ?",
    de: "Bereits ein Konto?",
    es: "¿Ya tienes una cuenta?"
  },
  "hero.login": {
    it: "Accedi",
    en: "Log in",
    fr: "Connexion",
    de: "Anmelden",
    es: "Iniciar sesión"
  },
  "section.features": {
    it: "Tutto quello che ti serve",
    en: "Everything you need",
    fr: "Tout ce dont vous avez besoin",
    de: "Alles was Sie brauchen",
    es: "Todo lo que necesitas"
  },
  "feature.landing_title": {
    it: "Landing Page Personalizzata",
    en: "Custom Landing Page",
    fr: "Page d'Atterrissage Personnalisée",
    de: "Individuelle Landingpage",
    es: "Landing Page Personalizada"
  },
  "feature.landing_desc": {
    it: "Crea una vetrina unica per la tua struttura con link, contatti e recensioni.",
    en: "Create a unique showcase for your property with links, contacts and reviews.",
    fr: "Créez une vitrine unique pour votre propriété avec liens, contacts et avis.",
    de: "Erstellen Sie ein einzigartiges Schaufenster für Ihre Unterkunft mit Links, Kontakten und Bewertungen.",
    es: "Crea un escaparate único para tu propiedad con enlaces, contactos y reseñas."
  },
  "feature.qr_title": {
    it: "QR Code Intelligente",
    en: "Smart QR Code",
    fr: "QR Code Intelligent",
    de: "Intelligenter QR-Code",
    es: "Código QR Inteligente"
  },
  "feature.qr_desc": {
    it: "Genera QR code brandizzati per i tuoi ospiti con statistiche di scansione.",
    en: "Generate branded QR codes for your guests with scan statistics.",
    fr: "Générez des QR codes personnalisés pour vos clients avec des statistiques de scan.",
    de: "Erstellen Sie gebrandete QR-Codes für Ihre Gäste mit Scan-Statistiken.",
    es: "Genera códigos QR de marca para tus huéspedes con estadísticas de escaneo."
  },
  "feature.reviews_title": {
    it: "Recensioni Google",
    en: "Google Reviews",
    fr: "Avis Google",
    de: "Google-Bewertungen",
    es: "Reseñas de Google"
  },
  "feature.reviews_desc": {
    it: "Importa e mostra le recensioni Google direttamente sulla tua landing.",
    en: "Import and display Google reviews directly on your landing page.",
    fr: "Importez et affichez les avis Google directement sur votre page.",
    de: "Importieren und zeigen Sie Google-Bewertungen direkt auf Ihrer Seite.",
    es: "Importa y muestra las reseñas de Google directamente en tu landing."
  },
  "feature.loyalty_title": {
    it: "Carta Fedeltà Digitale",
    en: "Digital Loyalty Card",
    fr: "Carte de Fidélité Numérique",
    de: "Digitale Treuekarte",
    es: "Tarjeta de Fidelidad Digital"
  },
  "feature.loyalty_desc": {
    it: "Fidelizza i tuoi ospiti con un programma a punti e premi personalizzati.",
    en: "Build guest loyalty with a points program and custom rewards.",
    fr: "Fidélisez vos clients avec un programme de points et des récompenses personnalisées.",
    de: "Binden Sie Gäste mit einem Punkteprogramm und individuellen Prämien.",
    es: "Fideliza a tus huéspedes con un programa de puntos y recompensas personalizadas."
  },
  "feature.chat_title": {
    it: "Chat con gli Ospiti",
    en: "Guest Chat",
    fr: "Chat avec les Clients",
    de: "Gäste-Chat",
    es: "Chat con Huéspedes"
  },
  "feature.chat_desc": {
    it: "Comunica direttamente con i tuoi ospiti in tempo reale.",
    en: "Communicate directly with your guests in real time.",
    fr: "Communiquez directement avec vos clients en temps réel.",
    de: "Kommunizieren Sie direkt mit Ihren Gästen in Echtzeit.",
    es: "Comunícate directamente con tus huéspedes en tiempo real."
  },
  "feature.stats_title": {
    it: "Statistiche Avanzate",
    en: "Advanced Analytics",
    fr: "Statistiques Avancées",
    de: "Erweiterte Statistiken",
    es: "Estadísticas Avanzadas"
  },
  "feature.stats_desc": {
    it: "Monitora visite, scansioni QR e performance della tua struttura.",
    en: "Monitor visits, QR scans and your property's performance.",
    fr: "Suivez les visites, les scans QR et les performances de votre propriété.",
    de: "Überwachen Sie Besuche, QR-Scans und die Performance Ihrer Unterkunft.",
    es: "Monitoriza visitas, escaneos QR y el rendimiento de tu propiedad."
  },
  "section.pricing": {
    it: "Piani e Prezzi",
    en: "Plans & Pricing",
    fr: "Plans et Tarifs",
    de: "Pläne & Preise",
    es: "Planes y Precios"
  },
  "pricing.monthly": {
    it: "Mensile",
    en: "Monthly",
    fr: "Mensuel",
    de: "Monatlich",
    es: "Mensual"
  },
  "pricing.annual": {
    it: "Annuale",
    en: "Annual",
    fr: "Annuel",
    de: "Jährlich",
    es: "Anual"
  },
  "pricing.month": {
    it: "/mese",
    en: "/month",
    fr: "/mois",
    de: "/Monat",
    es: "/mes"
  },
  "pricing.year": {
    it: "/anno",
    en: "/year",
    fr: "/an",
    de: "/Jahr",
    es: "/año"
  },
  "pricing.subscribe": {
    it: "Abbonati",
    en: "Subscribe",
    fr: "S'abonner",
    de: "Abonnieren",
    es: "Suscribirse"
  },
  "pricing.trial_cta": {
    it: "Prova gratis per 30 giorni e scopri tutte le funzionalità.",
    en: "Try free for 30 days and see all the cool things you can do.",
    fr: "Essayez gratuitement pendant 3 jours et découvrez tout ce que vous pouvez faire.",
    de: "Testen Sie 3 Tage kostenlos und entdecken Sie alle coolen Funktionen.",
    es: "Prueba gratis 3 días y descubre todas las cosas geniales que puedes hacer."
  },

  // ═══════════════════════════════════════
  // LOGIN PAGE
  // ═══════════════════════════════════════
  "login.title": {
    it: "Accedi",
    en: "Log In",
    fr: "Connexion",
    de: "Anmelden",
    es: "Iniciar Sesión"
  },
  "login.register_title": {
    it: "Registrati",
    en: "Sign Up",
    fr: "S'inscrire",
    de: "Registrieren",
    es: "Registrarse"
  },
  "login.email": {
    it: "Email",
    en: "Email",
    fr: "Email",
    de: "E-Mail",
    es: "Correo electrónico"
  },
  "login.password": {
    it: "Password",
    en: "Password",
    fr: "Mot de passe",
    de: "Passwort",
    es: "Contraseña"
  },
  "login.name": {
    it: "Nome completo",
    en: "Full name",
    fr: "Nom complet",
    de: "Vollständiger Name",
    es: "Nombre completo"
  },
  "login.submit": {
    it: "Accedi",
    en: "Log In",
    fr: "Connexion",
    de: "Anmelden",
    es: "Iniciar Sesión"
  },
  "login.register_submit": {
    it: "Registrati",
    en: "Sign Up",
    fr: "S'inscrire",
    de: "Registrieren",
    es: "Registrarse"
  },
  "login.no_account": {
    it: "Non hai un account?",
    en: "Don't have an account?",
    fr: "Vous n'avez pas de compte ?",
    de: "Kein Konto?",
    es: "¿No tienes una cuenta?"
  },
  "login.has_account": {
    it: "Hai già un account?",
    en: "Already have an account?",
    fr: "Vous avez déjà un compte ?",
    de: "Bereits ein Konto?",
    es: "¿Ya tienes una cuenta?"
  },
  "login.guest": {
    it: "Ospite",
    en: "Guest",
    fr: "Client",
    de: "Gast",
    es: "Huésped"
  },
  "login.host": {
    it: "Host / Property Manager",
    en: "Host / Property Manager",
    fr: "Hôte / Gestionnaire",
    de: "Gastgeber / Property Manager",
    es: "Anfitrión / Property Manager"
  },
  "login.guest_desc": {
    it: "Esplora strutture, messaggi e preferiti",
    en: "Explore properties, messages and favorites",
    fr: "Explorez les propriétés, messages et favoris",
    de: "Entdecken Sie Unterkünfte, Nachrichten und Favoriten",
    es: "Explora propiedades, mensajes y favoritos"
  },
  "login.host_desc": {
    it: "Gestisci le tue strutture e abbonamenti",
    en: "Manage your properties and subscriptions",
    fr: "Gérez vos propriétés et abonnements",
    de: "Verwalten Sie Ihre Unterkünfte und Abonnements",
    es: "Gestiona tus propiedades y suscripciones"
  },
  "login.or_google": {
    it: "oppure",
    en: "or",
    fr: "ou",
    de: "oder",
    es: "o"
  },
  "login.google_btn": {
    it: "Continua con Google",
    en: "Continue with Google",
    fr: "Continuer avec Google",
    de: "Weiter mit Google",
    es: "Continuar con Google"
  },

  // ═══════════════════════════════════════
  // DASHBOARD
  // ═══════════════════════════════════════
  "dash.messages": {
    it: "Messaggi",
    en: "Messages",
    fr: "Messages",
    de: "Nachrichten",
    es: "Mensajes"
  },
  "dash.new_msg": {
    it: "nuovi",
    en: "new",
    fr: "nouveaux",
    de: "neue",
    es: "nuevos"
  },
  "dash.new_msg_single": {
    it: "nuovo",
    en: "new",
    fr: "nouveau",
    de: "neue",
    es: "nuevo"
  },
  "dash.conversations": {
    it: "conversazioni",
    en: "conversations",
    fr: "conversations",
    de: "Unterhaltungen",
    es: "conversaciones"
  },
  "dash.conversation": {
    it: "conversazione",
    en: "conversation",
    fr: "conversation",
    de: "Unterhaltung",
    es: "conversación"
  },
  "dash.no_messages": {
    it: "Nessun messaggio ancora",
    en: "No messages yet",
    fr: "Aucun message encore",
    de: "Noch keine Nachrichten",
    es: "Aún no hay mensajes"
  },
  "dash.your_properties": {
    it: "Le tue proprietà",
    en: "Your Properties",
    fr: "Vos Propriétés",
    de: "Ihre Unterkünfte",
    es: "Tus Propiedades"
  },
  "dash.add_property": {
    it: "Aggiungi Struttura",
    en: "Add Property",
    fr: "Ajouter une Propriété",
    de: "Unterkunft Hinzufügen",
    es: "Añadir Propiedad"
  },
  "dash.no_properties": {
    it: "Non hai ancora strutture.",
    en: "You don't have any properties yet.",
    fr: "Vous n'avez pas encore de propriétés.",
    de: "Sie haben noch keine Unterkünfte.",
    es: "Aún no tienes propiedades."
  },
  "dash.create_first": {
    it: "Crea la tua Prima Struttura",
    en: "Create Your First Property",
    fr: "Créez Votre Première Propriété",
    de: "Erstellen Sie Ihre Erste Unterkunft",
    es: "Crea Tu Primera Propiedad"
  },
  "dash.edit": {
    it: "Modifica Struttura",
    en: "Edit Property",
    fr: "Modifier la Propriété",
    de: "Unterkunft Bearbeiten",
    es: "Editar Propiedad"
  },
  "dash.view_landing": {
    it: "Guarda Landing",
    en: "View Landing",
    fr: "Voir la Landing",
    de: "Landing Ansehen",
    es: "Ver Landing"
  },
  "dash.copy_link": {
    it: "Copia Link Pubblico",
    en: "Copy Public Link",
    fr: "Copier le Lien Public",
    de: "Öffentlichen Link Kopieren",
    es: "Copiar Enlace Público"
  },
  "dash.copied": {
    it: "Copiato!",
    en: "Copied!",
    fr: "Copié !",
    de: "Kopiert!",
    es: "¡Copiado!"
  },
  "dash.delete": {
    it: "Elimina",
    en: "Delete",
    fr: "Supprimer",
    de: "Löschen",
    es: "Eliminar"
  },
  "dash.published": {
    it: "Pubblicata",
    en: "Published",
    fr: "Publiée",
    de: "Veröffentlicht",
    es: "Publicada"
  },
  "dash.draft": {
    it: "Bozza",
    en: "Draft",
    fr: "Brouillon",
    de: "Entwurf",
    es: "Borrador"
  },
  "dash.quick_actions": {
    it: "Azioni Rapide",
    en: "Quick Actions",
    fr: "Actions Rapides",
    de: "Schnellaktionen",
    es: "Acciones Rápidas"
  },
  "dash.delete_confirm_title": {
    it: "Eliminare questa struttura?",
    en: "Delete this property?",
    fr: "Supprimer cette propriété ?",
    de: "Diese Unterkunft löschen?",
    es: "¿Eliminar esta propiedad?"
  },
  "dash.delete_confirm_desc": {
    it: "Questa azione è irreversibile. Tutti i dati, blog e statistiche verranno persi.",
    en: "This action is irreversible. All data, blogs and statistics will be lost.",
    fr: "Cette action est irréversible. Toutes les données, blogs et statistiques seront perdus.",
    de: "Diese Aktion ist unwiderruflich. Alle Daten, Blogs und Statistiken gehen verloren.",
    es: "Esta acción es irreversible. Todos los datos, blogs y estadísticas se perderán."
  },
  "dash.cancel": {
    it: "Annulla",
    en: "Cancel",
    fr: "Annuler",
    de: "Abbrechen",
    es: "Cancelar"
  },

  // ═══════════════════════════════════════
  // PROPERTY LANDING (Guest-facing)
  // ═══════════════════════════════════════
  "landing.reviews": {
    it: "Recensioni",
    en: "Reviews",
    fr: "Avis",
    de: "Bewertungen",
    es: "Reseñas"
  },
  "landing.amenities": {
    it: "Cosa troverai",
    en: "What you'll find",
    fr: "Ce que vous trouverez",
    de: "Was Sie finden werden",
    es: "Lo que encontrarás"
  },
  "landing.search_service": {
    it: "Cerca un servizio...",
    en: "Search a service...",
    fr: "Rechercher un service...",
    de: "Einen Service suchen...",
    es: "Buscar un servicio..."
  },
  "landing.no_results": {
    it: "Nessun risultato per",
    en: "No results for",
    fr: "Aucun résultat pour",
    de: "Keine Ergebnisse für",
    es: "Sin resultados para"
  },
  "landing.contact": {
    it: "Contatti",
    en: "Contact",
    fr: "Contact",
    de: "Kontakt",
    es: "Contacto"
  },
  "landing.book_now": {
    it: "Prenota su",
    en: "Book on",
    fr: "Réservez sur",
    de: "Buchen auf",
    es: "Reserva en"
  },
  "landing.chat_host": {
    it: "Chatta con l'host",
    en: "Chat with the host",
    fr: "Discuter avec l'hôte",
    de: "Mit dem Gastgeber chatten",
    es: "Chatea con el anfitrión"
  },
  "landing.send": {
    it: "Invia",
    en: "Send",
    fr: "Envoyer",
    de: "Senden",
    es: "Enviar"
  },
  "landing.your_name": {
    it: "Il tuo nome",
    en: "Your name",
    fr: "Votre nom",
    de: "Ihr Name",
    es: "Tu nombre"
  },
  "landing.your_email": {
    it: "La tua email",
    en: "Your email",
    fr: "Votre email",
    de: "Ihre E-Mail",
    es: "Tu correo"
  },
  "landing.message": {
    it: "Scrivi un messaggio...",
    en: "Write a message...",
    fr: "Écrire un message...",
    de: "Nachricht schreiben...",
    es: "Escribe un mensaje..."
  },
  "landing.blog": {
    it: "Dal Nostro Blog",
    en: "From Our Blog",
    fr: "De Notre Blog",
    de: "Aus Unserem Blog",
    es: "De Nuestro Blog"
  },
  "landing.powered_by": {
    it: "Realizzato con",
    en: "Powered by",
    fr: "Réalisé avec",
    de: "Erstellt mit",
    es: "Creado con"
  },
  "landing.questions": {
    it: "Hai domande?",
    en: "Any questions?",
    fr: "Des questions ?",
    de: "Haben Sie Fragen?",
    es: "¿Tienes preguntas?"
  },
  "landing.write_host": {
    it: "Scrivi all'Host",
    en: "Write to the Host",
    fr: "Écrire à l'Hôte",
    de: "Schreiben Sie dem Gastgeber",
    es: "Escribe al Anfitrión"
  },
  "landing.other_properties": {
    it: "Le Nostre Altre Strutture",
    en: "Our Other Properties",
    fr: "Nos Autres Propriétés",
    de: "Unsere Anderen Unterkünfte",
    es: "Nuestras Otras Propiedades"
  },
  "landing.guests": {
    it: "ospiti",
    en: "guests",
    fr: "voyageurs",
    de: "Gäste",
    es: "huéspedes"
  },
  "landing.rooms": {
    it: "camere",
    en: "rooms",
    fr: "chambres",
    de: "Zimmer",
    es: "habitaciones"
  },
  "landing.bathrooms": {
    it: "bagni",
    en: "bathrooms",
    fr: "salles de bain",
    de: "Bäder",
    es: "baños"
  },
  "cond.title": {
    it: "Condizioni di soggiorno",
    en: "Stay conditions",
    fr: "Conditions de séjour",
    de: "Aufenthaltsbedingungen",
    es: "Condiciones de estancia"
  },
  "cond.subtitle": {
    it: "Orari e regole della struttura",
    en: "Hours and house rules",
    fr: "Horaires et règles du logement",
    de: "Zeiten und Hausregeln",
    es: "Horarios y normas del alojamiento"
  },
  "cond.checkin": {
    it: "Check-in",
    en: "Check-in",
    fr: "Arrivée",
    de: "Check-in",
    es: "Check-in"
  },
  "cond.checkout": {
    it: "Check-out",
    en: "Check-out",
    fr: "Départ",
    de: "Check-out",
    es: "Check-out"
  },
  "cond.checkout_by": {
    it: "entro le",
    en: "by",
    fr: "avant",
    de: "bis",
    es: "antes de las"
  },
  "cond.pets": {
    it: "Animali",
    en: "Pets",
    fr: "Animaux",
    de: "Haustiere",
    es: "Mascotas"
  },
  "cond.adults_only": {
    it: "Solo adulti",
    en: "Adults only",
    fr: "Adultes uniquement",
    de: "Nur Erwachsene",
    es: "Solo adultos"
  },
  "cond.parking": {
    it: "Parcheggio privato",
    en: "Private parking",
    fr: "Parking privé",
    de: "Privatparkplatz",
    es: "Aparcamiento privado"
  },
  "cond.ev": {
    it: "Colonnina ricarica",
    en: "EV charging",
    fr: "Borne de recharge",
    de: "Ladestation",
    es: "Punto de recarga"
  },
  "cond.pets_yes": {
    it: "Ammessi",
    en: "Allowed",
    fr: "Admis",
    de: "Erlaubt",
    es: "Permitidos"
  },
  "cond.pets_no": {
    it: "Non ammessi",
    en: "Not allowed",
    fr: "Non admis",
    de: "Nicht erlaubt",
    es: "No permitidos"
  },
  "cond.yes": {
    it: "Sì",
    en: "Yes",
    fr: "Oui",
    de: "Ja",
    es: "Sí"
  },
  "cond.no": {
    it: "No",
    en: "No",
    fr: "Non",
    de: "Nein",
    es: "No"
  },
  "landing.home_tour": {
    it: "Home Tour",
    en: "Home Tour",
    fr: "Visite Virtuelle",
    de: "Hausrundgang",
    es: "Tour Virtual"
  },
  "landing.host_intro": {
    it: "Presentazione Host",
    en: "Host Introduction",
    fr: "Présentation de l'Hôte",
    de: "Gastgeber-Vorstellung",
    es: "Presentación del Anfitrión"
  },
  "landing.how_to_reach": {
    it: "Come raggiungerci",
    en: "How to reach us",
    fr: "Comment nous rejoindre",
    de: "So erreichen Sie uns",
    es: "Cómo llegar"
  },
  "landing.book_direct": {
    it: "Prenota Diretto",
    en: "Book Direct",
    fr: "Réservez Direct",
    de: "Direkt Buchen",
    es: "Reserva Directa"
  },
  "landing.insert_name": {
    it: "Come ti chiami?",
    en: "What's your name?",
    fr: "Comment vous appelez-vous ?",
    de: "Wie heißen Sie?",
    es: "¿Cómo te llamas?"
  },
  "landing.reply_email": {
    it: "Per ricevere risposte",
    en: "To receive replies",
    fr: "Pour recevoir des réponses",
    de: "Um Antworten zu erhalten",
    es: "Para recibir respuestas"
  },
  "landing.error_name": {
    it: "Inserisci il tuo nome",
    en: "Please enter your name",
    fr: "Veuillez entrer votre nom",
    de: "Bitte geben Sie Ihren Namen ein",
    es: "Por favor ingresa tu nombre"
  },
  "landing.error_message": {
    it: "Inserisci un messaggio",
    en: "Please enter a message",
    fr: "Veuillez entrer un message",
    de: "Bitte geben Sie eine Nachricht ein",
    es: "Por favor ingresa un mensaje"
  },
  "landing.message_sent": {
    it: "Messaggio inviato!",
    en: "Message sent!",
    fr: "Message envoyé !",
    de: "Nachricht gesendet!",
    es: "¡Mensaje enviado!"
  },
  "landing.error_send": {
    it: "Errore nell'invio",
    en: "Error sending message",
    fr: "Erreur lors de l'envoi",
    de: "Fehler beim Senden",
    es: "Error al enviar"
  },
  "landing.auto_translate_disclaimer": {
    it: "I contenuti sono tradotti automaticamente nella lingua del tuo browser.",
    en: "Content is automatically translated to your browser language.",
    fr: "Le contenu est traduit automatiquement dans la langue de votre navigateur.",
    de: "Inhalte werden automatisch in Ihre Browsersprache übersetzt.",
    es: "El contenido se traduce automáticamente al idioma de tu navegador."
  },

  // ═══════════════════════════════════════
  // PROFILE
  // ═══════════════════════════════════════
  "profile.title": {
    it: "Il tuo profilo",
    en: "Your Profile",
    fr: "Votre Profil",
    de: "Ihr Profil",
    es: "Tu Perfil"
  },
  "profile.change_password": {
    it: "Cambia Password",
    en: "Change Password",
    fr: "Changer le Mot de Passe",
    de: "Passwort Ändern",
    es: "Cambiar Contraseña"
  },
  "profile.current_password": {
    it: "Password attuale",
    en: "Current password",
    fr: "Mot de passe actuel",
    de: "Aktuelles Passwort",
    es: "Contraseña actual"
  },
  "profile.new_password": {
    it: "Nuova password",
    en: "New password",
    fr: "Nouveau mot de passe",
    de: "Neues Passwort",
    es: "Nueva contraseña"
  },
  "profile.confirm_password": {
    it: "Conferma nuova password",
    en: "Confirm new password",
    fr: "Confirmer le nouveau mot de passe",
    de: "Neues Passwort bestätigen",
    es: "Confirmar nueva contraseña"
  },
  "profile.update": {
    it: "Aggiorna",
    en: "Update",
    fr: "Mettre à jour",
    de: "Aktualisieren",
    es: "Actualizar"
  },
  "profile.subscription": {
    it: "Abbonamento",
    en: "Subscription",
    fr: "Abonnement",
    de: "Abonnement",
    es: "Suscripción"
  },
  "profile.manage_subscription": {
    it: "Gestisci Abbonamento",
    en: "Manage Subscription",
    fr: "Gérer l'Abonnement",
    de: "Abonnement Verwalten",
    es: "Gestionar Suscripción"
  },
  "profile.delete_account": {
    it: "Elimina Account",
    en: "Delete Account",
    fr: "Supprimer le Compte",
    de: "Konto Löschen",
    es: "Eliminar Cuenta"
  },
  "profile.delete_confirm": {
    it: "Conferma Eliminazione",
    en: "Confirm Deletion",
    fr: "Confirmer la Suppression",
    de: "Löschung Bestätigen",
    es: "Confirmar Eliminación"
  },
  "profile.logout": {
    it: "Esci",
    en: "Log Out",
    fr: "Déconnexion",
    de: "Abmelden",
    es: "Cerrar Sesión"
  },

  // ═══════════════════════════════════════
  // COMMON / SHARED
  // ═══════════════════════════════════════
  "common.save": {
    it: "Salva",
    en: "Save",
    fr: "Enregistrer",
    de: "Speichern",
    es: "Guardar"
  },
  "common.back": {
    it: "Indietro",
    en: "Back",
    fr: "Retour",
    de: "Zurück",
    es: "Volver"
  },
  "common.loading": {
    it: "Caricamento...",
    en: "Loading...",
    fr: "Chargement...",
    de: "Laden...",
    es: "Cargando..."
  },
  "common.error": {
    it: "Errore",
    en: "Error",
    fr: "Erreur",
    de: "Fehler",
    es: "Error"
  },
  "common.success": {
    it: "Successo",
    en: "Success",
    fr: "Succès",
    de: "Erfolg",
    es: "Éxito"
  },
  "common.search": {
    it: "Cerca...",
    en: "Search...",
    fr: "Rechercher...",
    de: "Suchen...",
    es: "Buscar..."
  },
  "common.close": {
    it: "Chiudi",
    en: "Close",
    fr: "Fermer",
    de: "Schließen",
    es: "Cerrar"
  },
  "common.continue": {
    it: "Continua",
    en: "Continue",
    fr: "Continuer",
    de: "Weiter",
    es: "Continuar"
  },

  // ═══════════════════════════════════════
  // COOKIE BANNER
  // ═══════════════════════════════════════
  "cookie.message": {
    it: "Questo sito utilizza i cookie per migliorare la tua esperienza.",
    en: "This site uses cookies to improve your experience.",
    fr: "Ce site utilise des cookies pour améliorer votre expérience.",
    de: "Diese Website verwendet Cookies, um Ihr Erlebnis zu verbessern.",
    es: "Este sitio usa cookies para mejorar tu experiencia."
  },
  "cookie.accept": {
    it: "Accetta tutti",
    en: "Accept All",
    fr: "Accepter tout",
    de: "Alle Akzeptieren",
    es: "Aceptar Todo"
  },
  "cookie.only_necessary": {
    it: "Solo necessari",
    en: "Only Necessary",
    fr: "Seulement nécessaires",
    de: "Nur Notwendige",
    es: "Solo Necesarias"
  },

  // ═══════════════════════════════════════
  // REVIEWS TAB
  // ═══════════════════════════════════════
  "reviews.all": {
    it: "Tutte", en: "All", fr: "Tous", de: "Alle", es: "Todas"
  },
  "reviews.location": {
    it: "Posizione", en: "Location", fr: "Emplacement", de: "Lage", es: "Ubicación"
  },
  "reviews.cleanliness": {
    it: "Pulizia", en: "Cleanliness", fr: "Propreté", de: "Sauberkeit", es: "Limpieza"
  },
  "reviews.communication": {
    it: "Comunicazione", en: "Communication", fr: "Communication", de: "Kommunikation", es: "Comunicación"
  },
  "reviews.checkin": {
    it: "Check-in", en: "Check-in", fr: "Check-in", de: "Check-in", es: "Check-in"
  },
  "reviews.value": {
    it: "Qualità/prezzo", en: "Value", fr: "Rapport qualité/prix", de: "Preis-Leistung", es: "Calidad/precio"
  },
  "reviews.accuracy": {
    it: "Precisione", en: "Accuracy", fr: "Précision", de: "Genauigkeit", es: "Precisión"
  },
  "reviews.count": {
    it: "recensioni", en: "reviews", fr: "avis", de: "Bewertungen", es: "reseñas"
  },
  "reviews.read_more": {
    it: "Leggi di più", en: "Read more", fr: "Lire la suite", de: "Mehr lesen", es: "Leer más"
  },
  "reviews.show_less": {
    it: "Mostra meno", en: "Show less", fr: "Voir moins", de: "Weniger anzeigen", es: "Mostrar menos"
  },
  "reviews.recent": {
    it: "Recenti", en: "Recent", fr: "Récents", de: "Neueste", es: "Recientes"
  },
  "reviews.highest": {
    it: "Voto più alto", en: "Highest rated", fr: "Mieux notés", de: "Höchste Bewertung", es: "Mejor valorados"
  },
  "reviews.lowest": {
    it: "Voto più basso", en: "Lowest rated", fr: "Moins bien notés", de: "Niedrigste Bewertung", es: "Peor valorados"
  },
  "reviews.no_reviews": {
    it: "Nessuna recensione per questa categoria", en: "No reviews for this category", fr: "Aucun avis pour cette catégorie", de: "Keine Bewertungen für diese Kategorie", es: "Sin reseñas para esta categoría"
  },
  "reviews.see_google": {
    it: "Vedi tutte su Google", en: "See all on Google", fr: "Voir tout sur Google", de: "Alle auf Google ansehen", es: "Ver todas en Google"
  },

  // ═══════════════════════════════════════
  // NOTIFICATIONS
  // ═══════════════════════════════════════
  "notif.title": {
    it: "Notifiche", en: "Notifications", fr: "Notifications", de: "Benachrichtigungen", es: "Notificaciones"
  },
  "notif.mark_read": {
    it: "Segna come lette", en: "Mark as read", fr: "Marquer comme lu", de: "Als gelesen markieren", es: "Marcar como leídas"
  },
  "notif.no_notifs": {
    it: "Nessuna notifica", en: "No notifications", fr: "Aucune notification", de: "Keine Benachrichtigungen", es: "Sin notificaciones"
  },

  // ═══════════════════════════════════════
  // FAQ (Landing)
  // ═══════════════════════════════════════
  "faq.title": {
    it: "Domande Frequenti",
    en: "Frequently Asked Questions",
    fr: "Questions Fréquentes",
    de: "Häufig Gestellte Fragen",
    es: "Preguntas Frecuentes"
  },
  "faq.subtitle": {
    it: "Tutto quello che devi sapere sugli affitti brevi e la disintermediazione",
    en: "Everything you need to know about short-term rentals and disintermediation",
    fr: "Tout ce que vous devez savoir sur la location saisonnière et la désintermédiation",
    de: "Alles was Sie über Kurzzeitvermietung und Disintermediation wissen müssen",
    es: "Todo lo que necesitas saber sobre los alquileres vacacionales y la desintermediación"
  },

  // ═══════════════════════════════════════
  // PUBLIC LANDING — PropertyLanding strings
  // ═══════════════════════════════════════
  "pl.availability.title": {
    it: "Disponibilità", en: "Availability", fr: "Disponibilité", de: "Verfügbarkeit", es: "Disponibilidad"
  },
  "pl.availability.subtitle": {
    it: "Le date verdi sono libere, le rosse occupate. Clicca su una data libera per contattare l'host.",
    en: "Green dates are available, red ones are booked. Click a free date to contact the host.",
    fr: "Les dates en vert sont disponibles, en rouge réservées. Cliquez sur une date libre pour contacter l'hôte.",
    de: "Grüne Termine sind frei, rote belegt. Klicke auf ein freies Datum, um den Gastgeber zu kontaktieren.",
    es: "Las fechas verdes están libres, las rojas ocupadas. Haz clic en una fecha libre para contactar al anfitrión."
  },
  "pl.availability.free": { it: "libere", en: "free", fr: "libres", de: "frei", es: "libres" },
  "pl.availability.busy": { it: "occupate", en: "booked", fr: "réservées", de: "belegt", es: "ocupadas" },
  "pl.availability.bookable": {
    it: "Disponibilità & Prenotazioni",
    en: "Availability & Booking",
    fr: "Disponibilité & Réservations",
    de: "Verfügbarkeit & Buchung",
    es: "Disponibilidad y Reservas"
  },
  "pl.availability.check_book": {
    it: "Verifica disponibilità e prenota direttamente qui sotto.",
    en: "Check availability and book directly below.",
    fr: "Vérifiez la disponibilité et réservez directement ci-dessous.",
    de: "Verfügbarkeit prüfen und direkt unten buchen.",
    es: "Consulta la disponibilidad y reserva directamente abajo."
  },
  "pl.availability.popup_label": {
    it: "Data disponibile", en: "Available date", fr: "Date disponible", de: "Verfügbares Datum", es: "Fecha disponible"
  },
  "pl.availability.contact_host": {
    it: "Contatta direttamente l'host per verificare la disponibilità e prenotare:",
    en: "Contact the host directly to confirm availability and book:",
    fr: "Contactez directement l'hôte pour confirmer la disponibilité et réserver :",
    de: "Kontaktiere den Gastgeber direkt, um Verfügbarkeit zu bestätigen und zu buchen:",
    es: "Contacta directamente al anfitrión para confirmar disponibilidad y reservar:"
  },
  "pl.availability.call": { it: "Chiama", en: "Call", fr: "Appeler", de: "Anrufen", es: "Llamar" },
  "pl.availability.write_to": { it: "Scrivi a", en: "Write to", fr: "Écrire à", de: "Schreiben an", es: "Escribe a" },
  "pl.availability.write_email": { it: "Scrivi una mail", en: "Send an email", fr: "Envoyer un e-mail", de: "E-Mail senden", es: "Enviar un correo" },
  "pl.availability.book_on": {
    it: "oppure prenota su", en: "or book on", fr: "ou réservez sur", de: "oder buche auf", es: "o reserva en"
  },
  "pl.availability.no_contacts": {
    it: "L'host non ha ancora configurato i contatti.",
    en: "The host hasn't configured contacts yet.",
    fr: "L'hôte n'a pas encore configuré les contacts.",
    de: "Der Gastgeber hat noch keine Kontakte konfiguriert.",
    es: "El anfitrión aún no ha configurado los contactos."
  },
  "pl.availability.loading": {
    it: "Caricamento calendario...", en: "Loading calendar...", fr: "Chargement du calendrier...", de: "Kalender wird geladen...", es: "Cargando calendario..."
  },

  // ─── Pricing disclaimer on public availability section ───
  "pl.pricing.with_guests": {
    it: "Il prezzo base è a partire da {price}, riferito a {guests}. Ospiti aggiuntivi e/o servizi saranno comunicati a seconda della richiesta.",
    en: "The starting price is {price}, based on {guests}. Additional guests and/or services will be quoted upon request.",
    fr: "Le prix de base est à partir de {price}, pour {guests}. Les invités supplémentaires et/ou services seront communiqués sur demande.",
    de: "Der Grundpreis beginnt bei {price}, für {guests}. Zusätzliche Gäste und/oder Services werden auf Anfrage mitgeteilt.",
    es: "El precio base es desde {price}, para {guests}. Huéspedes adicionales y/o servicios se comunicarán bajo solicitud."
  },
  "pl.pricing.without_guests": {
    it: "I prezzi riportati si intendono a partire da {price}. Eventuali costi o servizi aggiuntivi, o prezzi in base al numero di ospiti, verranno comunicati direttamente dall'host contattando i canali qui sotto.",
    en: "Displayed prices start from {price}. Additional costs, services or per-guest pricing will be communicated directly by the host via the channels below.",
    fr: "Les prix affichés partent de {price}. Les coûts, services ou tarifs par invité supplémentaires seront communiqués directement par l'hôte via les canaux ci-dessous.",
    de: "Die angezeigten Preise beginnen bei {price}. Zusätzliche Kosten, Services oder gastspezifische Preise werden vom Gastgeber direkt über die unten stehenden Kanäle mitgeteilt.",
    es: "Los precios mostrados parten de {price}. Costes, servicios o precios por huésped adicionales se comunicarán directamente por el anfitrión a través de los canales de abajo."
  },
  "pl.pricing.persons_one": { it: "1 persona", en: "1 person", fr: "1 personne", de: "1 Person", es: "1 persona" },
  "pl.pricing.persons_many": { it: "{n} persone", en: "{n} people", fr: "{n} personnes", de: "{n} Personen", es: "{n} personas" },
  "pl.pricing.extra_costs": { it: "Costi aggiuntivi", en: "Additional costs", fr: "Coûts supplémentaires", de: "Zusatzkosten", es: "Costos adicionales" },
  "pl.pricing.cleaning_fee": { it: "Spese di pulizia", en: "Cleaning fee", fr: "Frais de ménage", de: "Reinigungsgebühr", es: "Tarifa de limpieza" },
  "pl.pricing.tourist_tax": { it: "Imposta di soggiorno", en: "Tourist tax", fr: "Taxe de séjour", de: "Kurtaxe", es: "Tasa turística" },
  "pl.pricing.per_person_night": { it: "/pers/notte", en: "/pers/night", fr: "/pers/nuit", de: "/Pers./Nacht", es: "/pers/noche" },
  "pl.pricing.one_off": { it: "una tantum", en: "one-off", fr: "unique", de: "einmalig", es: "único" },
  "pl.pricing.min_nights_one": { it: "Soggiorno minimo: 1 notte", en: "Minimum stay: 1 night", fr: "Séjour minimum : 1 nuit", de: "Mindestaufenthalt: 1 Nacht", es: "Estancia mínima: 1 noche" },
  "pl.pricing.min_nights_many": { it: "Soggiorno minimo: {n} notti", en: "Minimum stay: {n} nights", fr: "Séjour minimum : {n} nuits", de: "Mindestaufenthalt: {n} Nächte", es: "Estancia mínima: {n} noches" },
  "pl.pricing.starting_from": { it: "A partire da", en: "Starting from", fr: "À partir de", de: "Ab", es: "Desde" },
  "pl.pricing.note_extra": {
    it: "Ospiti aggiuntivi e/o servizi comunicati in base alla richiesta.",
    en: "Additional guests and/or services quoted on request.",
    fr: "Invités supplémentaires et/ou services communiqués sur demande.",
    de: "Zusätzliche Gäste und/oder Services auf Anfrage.",
    es: "Huéspedes adicionales y/o servicios bajo solicitud."
  },
  "pl.availability.prev_month": { it: "Mese precedente", en: "Previous month", fr: "Mois précédent", de: "Vorheriger Monat", es: "Mes anterior" },
  "pl.availability.next_month": { it: "Mese successivo", en: "Next month", fr: "Mois suivant", de: "Nächster Monat", es: "Mes siguiente" },

  // ─── Amenities Treemap ───
  "pl.amenities.title": { it: "Servizi & Comfort", en: "Amenities & Comfort", fr: "Services & Confort", de: "Annehmlichkeiten & Komfort", es: "Servicios y Comodidades" },
  "pl.amenities.explore": {
    it: "Esplora cliccando una categoria", en: "Tap a category to explore", fr: "Cliquez sur une catégorie pour explorer", de: "Kategorie antippen zum Erkunden", es: "Toca una categoría para explorar"
  },
  "pl.amenities.items_one": { it: "voce", en: "item", fr: "élément", de: "Eintrag", es: "elemento" },
  "pl.amenities.items_many": { it: "voci", en: "items", fr: "éléments", de: "Einträge", es: "elementos" },

  // ─── Amenity category labels (used by Treemap) ───
  "pl.house_title": { it: "La casa", en: "The home", fr: "La maison", de: "Das Zuhause", es: "La casa" },
  "pl.open_in_map": { it: "Apri in mappa", en: "Open in map", fr: "Ouvrir dans la carte", de: "In Karte öffnen", es: "Abrir en el mapa" },

  // ─── How to book — unified section (replaces "Contatti" + "Prenota su") ───
  "htb.eyebrow": { it: "Come prenotare", en: "How to book", fr: "Comment réserver", de: "So buchst du", es: "Cómo reservar" },
  "htb.title": { it: "Scegli il tuo modo preferito", en: "Choose your preferred way", fr: "Choisissez votre méthode préférée", de: "Wähle deinen bevorzugten Weg", es: "Elige tu modo preferido" },
  "htb.subtitle": { it: "Contattaci direttamente o prenota su una delle nostre piattaforme partner.", en: "Reach out directly or book on one of our partner platforms.", fr: "Contactez-nous directement ou réservez sur l'une de nos plateformes partenaires.", de: "Kontaktiere uns direkt oder buche auf einer unserer Partnerplattformen.", es: "Contáctanos directamente o reserva en una de nuestras plataformas asociadas." },
  // ─── Section headers per "Informazioni generali" e "La struttura" ───
  "sec.info.eyebrow":    { it: "Informazioni generali", en: "General info",       fr: "Informations générales", de: "Allgemeine Infos",    es: "Información general" },
  "sec.info.title":      { it: "Panoramica della struttura", en: "Property overview", fr: "Aperçu du logement",  de: "Überblick",          es: "Resumen del alojamiento" },
  "sec.info.subtitle":   { it: "Occupazione, popolarità, spazi e meteo locale.", en: "Occupancy, popularity, spaces and local weather.", fr: "Occupation, popularité, espaces et météo locale.", de: "Belegung, Beliebtheit, Räume und lokales Wetter.", es: "Ocupación, popularidad, espacios y clima local." },
  "sec.house.eyebrow":   { it: "La struttura", en: "The property",       fr: "Le logement",         de: "Die Unterkunft",     es: "El alojamiento" },
  "sec.house.title":     { it: "Tutto sulla casa", en: "Everything about the home", fr: "Tout sur le logement", de: "Alles zur Unterkunft", es: "Todo sobre la casa" },
  "sec.house.subtitle":  { it: "Mappa, punti di interesse, servizi e descrizione.", en: "Map, points of interest, amenities and description.", fr: "Carte, points d'intérêt, équipements et description.", de: "Karte, Sehenswürdigkeiten, Ausstattung und Beschreibung.", es: "Mapa, puntos de interés, servicios y descripción." },
  "sec.video.eyebrow":   { it: "Guarda i video", en: "Watch the videos", fr: "Regarde les vidéos", de: "Sieh die Videos", es: "Mira los vídeos" },
  "sec.video.title":     { it: "Video è meglio!", en: "Video is better!", fr: "La vidéo, c'est mieux !", de: "Video ist besser!", es: "¡Vídeo es mejor!" },
  "sec.video.subtitle":  { it: "Tour della casa e invito del tuo host — bastano 30 secondi.", en: "Home tour and host welcome — just 30 seconds.", fr: "Visite de la maison et invitation de l'hôte — 30 secondes seulement.", de: "Rundgang und Gastgeber-Gruß — nur 30 Sekunden.", es: "Tour de la casa e invitación del anfitrión — solo 30 segundos." },
  // ─── Host seniority (Airbnb-style "X anni da host") ───
  "host.years_one":   { it: "1 anno da host",  en: "1 year hosting",  fr: "1 an d'hébergement",   de: "1 Jahr als Gastgeber",   es: "1 año como anfitrión" },
  "host.years_many":  { it: "{n} anni da host", en: "{n} years hosting", fr: "{n} ans d'hébergement", de: "{n} Jahre als Gastgeber", es: "{n} años como anfitrión" },
  "host.months_one":  { it: "1 mese da host",  en: "1 month hosting", fr: "1 mois d'hébergement", de: "1 Monat als Gastgeber",   es: "1 mes como anfitrión" },
  "host.months_many": { it: "{n} mesi da host", en: "{n} months hosting", fr: "{n} mois d'hébergement", de: "{n} Monate als Gastgeber", es: "{n} meses como anfitrión" },
  "host.new":         { it: "Nuovo su Hostland", en: "New on Hostland", fr: "Nouveau sur Hostland", de: "Neu bei Hostland",     es: "Nuevo en Hostland" },
  "htb.direct": { it: "Contattaci direttamente", en: "Contact us directly", fr: "Contactez-nous directement", de: "Direkt kontaktieren", es: "Contáctanos directamente" },
  "htb.platforms": { it: "Prenota sulle piattaforme", en: "Book on platforms", fr: "Réservez sur les plateformes", de: "Auf Plattformen buchen", es: "Reserva en las plataformas" },
  "htb.platforms_hint": { it: "Tariffe e disponibilità ufficiali", en: "Official rates & availability", fr: "Tarifs et disponibilité officiels", de: "Offizielle Preise & Verfügbarkeit", es: "Tarifas y disponibilidad oficiales" },
  "htb.call": { it: "Chiama", en: "Call", fr: "Appeler", de: "Anrufen", es: "Llamar" },
  "htb.tap_to_call": { it: "Tocca per chiamare", en: "Tap to call", fr: "Appuyez pour appeler", de: "Tippen zum Anrufen", es: "Toca para llamar" },
  "htb.tap_to_email": { it: "Tocca per scrivere", en: "Tap to email", fr: "Appuyez pour écrire", de: "Tippen zum Schreiben", es: "Toca para escribir" },
  "htb.chat": { it: "Chat", en: "Chat", fr: "Chat", de: "Chat", es: "Chat" },
  "htb.official": { it: "Sito ufficiale", en: "Official site", fr: "Site officiel", de: "Offizielle Website", es: "Sitio oficial" },

  // ─── KPI cards (Occupancy / Views / Weather) — hardcoded labels now translatable ───
  "kpi.occupancy_90": { it: "Tasso occupazione", en: "Occupancy rate", fr: "Taux d'occupation", de: "Auslastungsrate", es: "Tasa de ocupación" },
  "kpi.occupancy_high": { it: "Prenota subito, quasi pieno", en: "Book now, almost full", fr: "Réservez vite, presque complet", de: "Schnell buchen, fast voll", es: "Reserva ya, casi lleno" },
  "kpi.occupancy_mid": { it: "Disponibilità buona", en: "Good availability", fr: "Bonne disponibilité", de: "Gute Verfügbarkeit", es: "Buena disponibilidad" },
  "kpi.occupancy_low": { it: "Tante date libere", en: "Plenty of dates open", fr: "Beaucoup de dates libres", de: "Viele freie Daten", es: "Muchas fechas libres" },
  "kpi.views": { it: "Visite", en: "Visits", fr: "Visites", de: "Besuche", es: "Visitas" },
  "kpi.views_sub": { it: "Visite totali dal lancio", en: "Total visits since launch", fr: "Visites totales depuis le lancement", de: "Besuche seit dem Start", es: "Visitas totales desde el lanzamiento" },
  "kpi.weather_week": { it: "Meteo 4 giorni", en: "4-day weather", fr: "Météo 4 jours", de: "4-Tage Wetter", es: "Tiempo 4 días" },
  "kpi.weather_unavailable": { it: "Meteo non disponibile", en: "Weather unavailable", fr: "Météo indisponible", de: "Wetter nicht verfügbar", es: "Meteo no disponible" },
  "kpi.weather_now": { it: "Meteo ora", en: "Weather now", fr: "Météo maintenant", de: "Wetter jetzt", es: "Tiempo ahora" },
  "kpi.weather_live": { it: "Live", en: "Live", fr: "Live", de: "Live", es: "Live" },
  "kpi.weather_feels": { it: "Percepiti", en: "Feels", fr: "Ressenti", de: "Gefühlt", es: "Sensación" },
  "kpi.weather_wind": { it: "Vento km/h", en: "Wind km/h", fr: "Vent km/h", de: "Wind km/h", es: "Viento km/h" },

  // Day short names — used by the 7-day weather widget
  "day.today": { it: "Oggi", en: "Today", fr: "Auj.", de: "Heute", es: "Hoy" },
  "day.sun_short": { it: "Dom", en: "Sun", fr: "Dim", de: "So", es: "Dom" },
  "day.mon_short": { it: "Lun", en: "Mon", fr: "Lun", de: "Mo", es: "Lun" },
  "day.tue_short": { it: "Mar", en: "Tue", fr: "Mar", de: "Di", es: "Mar" },
  "day.wed_short": { it: "Mer", en: "Wed", fr: "Mer", de: "Mi", es: "Mié" },
  "day.thu_short": { it: "Gio", en: "Thu", fr: "Jeu", de: "Do", es: "Jue" },
  "day.fri_short": { it: "Ven", en: "Fri", fr: "Ven", de: "Fr", es: "Vie" },
  "day.sat_short": { it: "Sab", en: "Sat", fr: "Sam", de: "Sa", es: "Sáb" },

  // ─── Blog / News box ("Aggiornamenti") ───
  "news.live": { it: "Aggiornamenti Live", en: "Live Updates", fr: "Mises à jour en direct", de: "Live-Updates", es: "Actualizaciones en vivo" },
  "news.other": { it: "Altri aggiornamenti", en: "Other updates", fr: "Autres mises à jour", de: "Weitere Updates", es: "Otras actualizaciones" },
  "news.video": { it: "Video", en: "Video", fr: "Vidéo", de: "Video", es: "Vídeo" },
  "news.audio": { it: "Audio", en: "Audio", fr: "Audio", de: "Audio", es: "Audio" },
  "news.open_link": { it: "Apri link", en: "Open link", fr: "Ouvrir le lien", de: "Link öffnen", es: "Abrir enlace" },
  "news.video_fallback": { it: "Se il video non parte, aprilo su YouTube", en: "If the video does not play, open it on YouTube", fr: "Si la vidéo ne démarre pas, ouvrez-la sur YouTube", de: "Wenn das Video nicht startet, öffne es auf YouTube", es: "Si el vídeo no se reproduce, ábrelo en YouTube" },
  "pl.book_anywhere": { it: "Prenota dove preferisci", en: "Book wherever you prefer", fr: "Réservez où vous préférez", de: "Buche wo du möchtest", es: "Reserva donde prefieras" },
  "pl.book_on": { it: "Prenota su", en: "Book on", fr: "Réserver sur", de: "Buchen auf", es: "Reservar en" },
  "pl.reply_minutes": { it: "Ti rispondiamo entro pochi minuti", en: "We reply within minutes", fr: "Nous répondons en quelques minutes", de: "Wir antworten in wenigen Minuten", es: "Respondemos en pocos minutos" },
  "pl.contact_host": { it: "Contatta l'host", en: "Contact the host", fr: "Contacter l'hôte", de: "Gastgeber kontaktieren", es: "Contactar al anfitrión" },
  "pl.save_loyalty": { it: "Salva i preferiti e ottieni la Carta Fedeltà", en: "Save favorites and earn the Loyalty Card", fr: "Enregistrez vos favoris et obtenez la Carte de Fidélité", de: "Favoriten speichern und Treuekarte erhalten", es: "Guarda favoritos y obtén la Tarjeta de Fidelidad" },
  "landing.register_free": { it: "Registrati gratis", en: "Sign up for free", fr: "Inscrivez-vous gratuitement", de: "Kostenlos registrieren", es: "Regístrate gratis" },
  "landing.signup": { it: "Registrati", en: "Sign up", fr: "S'inscrire", de: "Registrieren", es: "Regístrate" },
  "pl.cat.bagno": { it: "Bagno", en: "Bathroom", fr: "Salle de bain", de: "Badezimmer", es: "Baño" },
  "pl.cat.camera": { it: "Camera da letto", en: "Bedroom", fr: "Chambre", de: "Schlafzimmer", es: "Dormitorio" },
  "pl.cat.lavanderia": { it: "Lavanderia", en: "Laundry", fr: "Buanderie", de: "Wäscherei", es: "Lavandería" },
  "pl.cat.cucina": { it: "Cucina", en: "Kitchen", fr: "Cuisine", de: "Küche", es: "Cocina" },
  "pl.cat.soggiorno": { it: "Soggiorno", en: "Living room", fr: "Salon", de: "Wohnzimmer", es: "Sala de estar" },
  "pl.cat.intrattenimento": { it: "Intrattenimento", en: "Entertainment", fr: "Divertissement", de: "Unterhaltung", es: "Entretenimiento" },
  "pl.cat.internet": { it: "Internet", en: "Internet", fr: "Internet", de: "Internet", es: "Internet" },
  "pl.cat.climatizzazione": { it: "Climatizzazione", en: "Climate control", fr: "Climatisation", de: "Klimatisierung", es: "Climatización" },
  "pl.cat.sicurezza": { it: "Sicurezza", en: "Safety", fr: "Sécurité", de: "Sicherheit", es: "Seguridad" },
  "pl.cat.esterno": { it: "Esterno", en: "Outdoor", fr: "Extérieur", de: "Außenbereich", es: "Exterior" },
  "pl.cat.parcheggio": { it: "Parcheggio", en: "Parking", fr: "Parking", de: "Parkplatz", es: "Aparcamiento" },
  "pl.cat.famiglia": { it: "Famiglia", en: "Family", fr: "Famille", de: "Familie", es: "Familia" },
  "pl.cat.accessibilita": { it: "Accessibilità", en: "Accessibility", fr: "Accessibilité", de: "Barrierefreiheit", es: "Accesibilidad" },
  "pl.cat.eco": { it: "Eco-Sostenibilità", en: "Eco-friendly", fr: "Éco-responsable", de: "Nachhaltigkeit", es: "Ecológico" },
  "pl.cat.benessere": { it: "Benessere & Sport", en: "Wellness & Sport", fr: "Bien-être & Sport", de: "Wellness & Sport", es: "Bienestar y Deporte" },
  "pl.cat.servizi": { it: "Servizi extra", en: "Extra services", fr: "Services supplémentaires", de: "Zusatzleistungen", es: "Servicios extra" },
  "pl.cat.altro": { it: "Altro", en: "Other", fr: "Autre", de: "Sonstiges", es: "Otro" },

  // ═══════════════════════════════════════
  // LANDING PAGE — NEW HOMEPAGE (Feb 2026 redesign)
  // ═══════════════════════════════════════
  // Nav
  "lp.nav.site": { it: "Sito", en: "Site", fr: "Site", de: "Website", es: "Sitio" },
  "lp.nav.guestapp": { it: "Welcome Book", en: "Welcome Book", fr: "Welcome Book", de: "Welcome Book", es: "Welcome Book" },
  "lp.nav.parkhost": { it: "ParkHost", en: "ParkHost", fr: "ParkHost", de: "ParkHost", es: "ParkHost" },
  "lp.nav.pricing": { it: "Prezzi", en: "Pricing", fr: "Tarifs", de: "Preise", es: "Precios" },
  "lp.pro.home_teaser": { it: "Hai un'attività locale? Entra in Hostland Pro e raggiungi centinaia di ospiti", en: "Run a local business? Join Hostland Pro and reach hundreds of guests", fr: "Vous avez un commerce local ? Rejoignez Hostland Pro et touchez des centaines de voyageurs", de: "Lokales Geschäft? Werde Teil von Hostland Pro und erreiche Hunderte Gäste", es: "¿Tienes un negocio local? Únete a Hostland Pro y llega a cientos de huéspedes" },
  "lp.nav.login": { it: "Accedi", en: "Log in", fr: "Connexion", de: "Anmelden", es: "Acceder" },
  "lp.nav.dashboard": { it: "Dashboard", en: "Dashboard", fr: "Tableau de bord", de: "Dashboard", es: "Panel" },

  // Toggle
  "lp.toggle.host": { it: "Host / PM", en: "Host / PM", fr: "Hôte / PM", de: "Host / PM", es: "Host / PM" },
  "lp.toggle.guest": { it: "Viaggiatore", en: "Traveler", fr: "Voyageur", de: "Reisender", es: "Viajero" },

  // Hero
  "lp.hero.brand_note": { it: "Un servizio di", en: "A service by", fr: "Un service de", de: "Ein Service von", es: "Un servicio de" },
  "lp.hero.eyebrow.host": { it: "Il maggiordomo digitale per i tuoi ospiti", en: "The digital butler for your guests", fr: "Le majordome numérique pour vos hôtes", de: "Der digitale Butler für Ihre Gäste", es: "El mayordomo digital para tus huéspedes" },
  "lp.hero.eyebrow.guest": { it: "Prenotazioni dirette · zero commissioni", en: "Direct bookings · zero commissions", fr: "Réservations directes · zéro commission", de: "Direktbuchungen · null Provisionen", es: "Reservas directas · cero comisiones" },
  "lp.hero.title.line1": { it: "La tua Ospitalità.", en: "Your Hospitality.", fr: "Votre Hospitalité.", de: "Ihre Gastfreundschaft.", es: "Tu Hospitalidad." },
  "lp.hero.rot.1": { it: "Senza Confini.", en: "Without Borders.", fr: "Sans Frontières.", de: "Ohne Grenzen.", es: "Sin Fronteras." },
  "lp.hero.rot.2": { it: "Senza Filtri.", en: "Without Filters.", fr: "Sans Filtres.", de: "Ohne Filter.", es: "Sin Filtros." },
  "lp.hero.rot.3": { it: "No Commissioni.", en: "No Commissions.", fr: "Sans Commissions.", de: "Ohne Provisionen.", es: "Sin Comisiones." },
  "lp.hero.sub.host_line1": { it: "Sito web, Welcome Book Digitale multilingua, QR code, Tour AI, mappa, calendari sincronizzati e invio automatico ad Alloggiati Web e ISTAT dal Welcome Book.", en: "Website, multilingual digital Welcome Book, QR code, AI Tours, map, synced calendars and automatic submission to Alloggiati Web and ISTAT from the Welcome Book.", fr: "Site web, Welcome Book Numérique multilingue, QR code, Tours IA, carte, calendriers synchronisés et envoi automatique à Alloggiati Web et ISTAT depuis le Welcome Book.", de: "Website, mehrsprachiges digitales Welcome Book, QR-Code, KI-Touren, Karte, synchronisierte Kalender und automatische Übermittlung an Alloggiati Web und ISTAT aus dem Welcome Book.", es: "Sitio web, Welcome Book Digital multilingüe, código QR, Tours IA, mapa, calendarios sincronizados y envío automático a Alloggiati Web e ISTAT desde el Welcome Book." },
  "lp.hero.sub.host_line2": { it: "Tutto da un'unica dashboard.", en: "All from a single dashboard.", fr: "Tout depuis un seul tableau de bord.", de: "Alles über ein einziges Dashboard.", es: "Todo desde un único panel." },
  "lp.hero.sub.host_line3": { it: "Per host, property manager, B&B, agriturismo, boutique hotel, e per chi ha un posto auto da valorizzare.", en: "For hosts, property managers, B&Bs, farm stays, boutique hotels — and anyone with a parking spot to monetize.", fr: "Pour hôtes, property managers, B&B, agritourismes, hôtels boutique — et pour qui a une place de parking à valoriser.", de: "Für Hosts, Property Manager, B&Bs, Agritourismus, Boutique-Hotels — und alle, die einen Parkplatz vermieten möchten.", es: "Para hosts, property managers, B&B, agroturismos, hoteles boutique — y para quien tiene una plaza de aparcamiento que rentabilizar." },
  "lp.hero.sub.guest_line1": { it: "Scopri strutture uniche in tutta Italia.", en: "Discover unique properties across Italy.", fr: "Découvrez des logements uniques dans toute l'Italie.", de: "Entdecke einzigartige Unterkünfte in ganz Italien.", es: "Descubre alojamientos únicos en toda Italia." },
  "lp.hero.sub.guest_line2": { it: "Contatta direttamente l'host, senza intermediari.", en: "Contact the host directly, no middleman.", fr: "Contactez l'hôte directement, sans intermédiaires.", de: "Kontaktiere den Gastgeber direkt, ohne Zwischenhändler.", es: "Contacta directamente al host, sin intermediarios." },
  "lp.hero.sub.guest_line3": { it: "Ricevi il Welcome Book Digitale con Wi-Fi, mappe, meteo, manuali della casa e concierge locale — tutto già pronto per il tuo soggiorno.", en: "Get the digital Welcome Book with Wi-Fi, maps, weather, house manuals and local concierge — ready for your stay.", fr: "Recevez le Welcome Book Numérique avec Wi-Fi, cartes, météo, manuels de la maison et concierge local — tout prêt pour votre séjour.", de: "Erhalte das digitale Welcome Book mit WLAN, Karten, Wetter, Hausanleitungen und lokalem Concierge — alles bereit für deinen Aufenthalt.", es: "Recibe el Welcome Book Digital con Wi-Fi, mapas, tiempo, manuales de la casa y concierge local — todo listo para tu estancia." },

  // Search bar
  "lp.search.destination_label": { it: "Dove vuoi andare?", en: "Where to?", fr: "Où voulez-vous aller ?", de: "Wohin?", es: "¿A dónde?" },
  "lp.search.destination_ph": { it: "Es. Milano, Roma, Firenze...", en: "e.g. Milan, Rome, Florence...", fr: "Ex. Milan, Rome, Florence...", de: "z. B. Mailand, Rom, Florenz...", es: "Ej. Milán, Roma, Florencia..." },
  "lp.search.guests": { it: "Ospiti", en: "Guests", fr: "Voyageurs", de: "Gäste", es: "Huéspedes" },
  "lp.search.checkin": { it: "Check-in", en: "Check-in", fr: "Arrivée", de: "Anreise", es: "Entrada" },
  "lp.search.checkout": { it: "Check-out", en: "Check-out", fr: "Départ", de: "Abreise", es: "Salida" },
  "lp.search.submit": { it: "Cerca alloggi", en: "Search stays", fr: "Rechercher", de: "Suchen", es: "Buscar alojamientos" },
  "lp.search.note": { it: "Zero commissioni · contatto diretto con l'host", en: "Zero commissions · direct contact with the host", fr: "Zéro commission · contact direct avec l'hôte", de: "Null Provisionen · direkter Kontakt zum Gastgeber", es: "Cero comisiones · contacto directo con el host" },

  // Host primary CTA
  "lp.cta.trial": { it: "Inizia gratis · 30 giorni di prova", en: "Start free · 30-day trial", fr: "Commencer gratuit · 30 jours d'essai", de: "Kostenlos starten · 30 Tage Test", es: "Empieza gratis · 30 días de prueba" },
  "lp.cta.trial_short": { it: "30 giorni di prova", en: "30-day trial", fr: "30 jours d'essai", de: "30 Tage Test", es: "30 días de prueba" },
  "lp.cta.parkhost_pill": { it: "Diventa ParkHost · €4,99/anno", en: "Become a ParkHost · €4.99/year", fr: "Devenir ParkHost · 4,99 €/an", de: "ParkHost werden · 4,99 €/Jahr", es: "Hazte ParkHost · 4,99 €/año" },
  "lp.cta.search_as_guest": { it: "Cerca alloggi come viaggiatore", en: "Search as a traveler", fr: "Chercher comme voyageur", de: "Als Reisender suchen", es: "Buscar como viajero" },
  "lp.cta.host_preview": { it: "Sei un host? Scopri Hostland", en: "Are you a host? Discover Hostland", fr: "Vous êtes hôte ? Découvrez Hostland", de: "Bist du Gastgeber? Entdecke Hostland", es: "¿Eres host? Descubre Hostland" },
  "lp.cta.leaderboard": { it: "Classifica Host", en: "Host Ranking", fr: "Classement Hôtes", de: "Host-Ranking", es: "Ranking Hosts" },

  // Stats
  "lp.stat.made_it": { it: "Made in Italy", en: "Made in Italy", fr: "Made in Italy", de: "Made in Italy", es: "Made in Italy" },
  "lp.stat.setup": { it: "Setup", en: "Setup", fr: "Setup", de: "Setup", es: "Setup" },
  "lp.stat.commissioni": { it: "Commissioni", en: "Commissions", fr: "Commissions", de: "Provisionen", es: "Comisiones" },
  "lp.stat.lingue": { it: "Lingue", en: "Languages", fr: "Langues", de: "Sprachen", es: "Idiomas" },
  "lp.stat.online": { it: "Online", en: "Online", fr: "En ligne", de: "Online", es: "En línea" },

  // Section — Sito Web
  "lp.site.eyebrow": { it: "Il tuo Sito Hostland", en: "Your Hostland Site", fr: "Votre Site Hostland", de: "Deine Hostland-Site", es: "Tu Sitio Hostland" },
  "lp.site.title": { it: "Sito per case vacanze con prenotazione diretta", en: "A landing page", fr: "Une landing page", de: "Eine Landing Page", es: "Una landing page" },
  "lp.site.title_grad": { it: "senza commissioni", en: "that converts", fr: "qui convertit", de: "die konvertiert", es: "que convierte" },
  "lp.site.sub": { it: "Grafica moderna e unica, gallery, video, mappa, prezzi, calendario iCal, prenotazione diretta, recensioni Google, traduzioni automatiche. SEO + GEO ottimizzati.", en: "Modern unique design, gallery, video, map, pricing, iCal calendar, direct booking, Google reviews, auto translations. SEO + GEO optimized.", fr: "Design moderne unique, galerie, vidéo, carte, tarifs, calendrier iCal, réservation directe, avis Google, traductions automatiques. SEO + GEO optimisés.", de: "Modernes einzigartiges Design, Galerie, Video, Karte, Preise, iCal-Kalender, Direktbuchung, Google-Bewertungen, automatische Übersetzungen. SEO + GEO optimiert.", es: "Diseño moderno único, galería, vídeo, mapa, precios, calendario iCal, reserva directa, reseñas Google, traducciones automáticas. SEO + GEO optimizado." },
  "lp.site.cta": { it: "Crea il tuo sito Hostland gratis", en: "Create your Hostland site free", fr: "Créez votre site Hostland gratuitement", de: "Erstelle deine Hostland-Site gratis", es: "Crea tu sitio Hostland gratis" },

  // Promo video overlay ({...} = highlighted word)
  "lp.promo_video.title": { it: "Sai dove te lo puoi mettere il {link}?", en: "Do you know where you can put the {link}?", fr: "Sais-tu où tu peux mettre le {lien} ?", de: "Weißt du, wohin du den {Link} packen kannst?", es: "¿Sabes dónde puedes poner el {enlace}?" },
  "lp.promo_video.sub": { it: "Link in bio su Instagram e TikTok · nelle storie · post su Facebook · via mail — e ti diamo anche il {QR code} pronto per i tuoi biglietti da visita.", en: "Link in your Instagram and TikTok bio · in stories · Facebook posts · by email — and we also give you the {QR code} ready for your business cards.", fr: "Lien dans la bio Instagram et TikTok · dans les stories · posts Facebook · par e-mail — et on te donne aussi le {QR code} prêt pour tes cartes de visite.", de: "Link in deiner Instagram- und TikTok-Bio · in Storys · Facebook-Posts · per E-Mail — und wir geben dir auch den {QR code} fertig für deine Visitenkarten.", es: "Enlace en la bio de Instagram y TikTok · en las historias · posts de Facebook · por email — y también te damos el {QR code} listo para tus tarjetas de visita." },

  // Section — Welcome Book Digitale
  "lp.gb.eyebrow": { it: "Il GuestBook diventa Welcome Book Digitale", en: "The GuestBook becomes the digital Welcome Book", fr: "Le GuestBook devient Welcome Book Numérique", de: "Das GuestBook wird zum digitalen Welcome Book", es: "El GuestBook se convierte en Welcome Book Digital" },
  "lp.gb.title": { it: "Welcome Book: la guida digitale per ospiti", en: "The private WebApp", fr: "La WebApp privée", de: "Die private WebApp", es: "La WebApp privada" },
  "lp.gb.title_grad": { it: "dei tuoi ospiti", en: "for your guests", fr: "de vos hôtes", de: "für deine Gäste", es: "de tus huéspedes" },
  "lp.gb.sub": { it: "Un link, un click e tu non dovrai fare più nulla, mentre il tuo ospite avrà tutto il mondo che hai creato per lui: Wi-Fi, mappe, traduzioni, meteo, manuali della casa, parcheggi, emergenze e molto altro. Già tradotto, già super pop.", en: "One link, one click and you don't have to do anything more — while your guest gets the whole world you built for them: Wi-Fi, maps, translations, weather, house manuals, parking, emergencies and much more. Already translated, already pop.", fr: "Un lien, un clic et vous n'aurez plus rien à faire — pendant que votre hôte aura tout l'univers que vous avez créé pour lui : Wi-Fi, cartes, traductions, météo, manuels de la maison, parkings, urgences et bien plus. Déjà traduit, déjà pop.", de: "Ein Link, ein Klick und du musst nichts mehr tun — während dein Gast die ganze Welt bekommt, die du für ihn erschaffen hast: WLAN, Karten, Übersetzungen, Wetter, Hausanleitungen, Parkplätze, Notfälle und vieles mehr. Bereits übersetzt, bereits pop.", es: "Un enlace, un clic y no tendrás que hacer nada más — mientras tu huésped tendrá todo el mundo que has creado para él: Wi-Fi, mapas, traducciones, tiempo, manuales de la casa, aparcamientos, emergencias y mucho más. Ya traducido, ya pop." },
  "lp.gb.cta": { it: "Attiva il Welcome Book Digitale", en: "Activate the digital Welcome Book", fr: "Activer le Welcome Book Numérique", de: "Digitales Welcome Book aktivieren", es: "Activa el Welcome Book Digital" },

  // Section — ParkHost
  "lp.pk.badge": { it: "ParkHost · Nuovo modulo", en: "ParkHost · New module", fr: "ParkHost · Nouveau module", de: "ParkHost · Neues Modul", es: "ParkHost · Nuevo módulo" },
  "lp.pk.title_1": { it: "Affitta il tuo", en: "Turn your", fr: "Transformez votre", de: "Verwandle deinen", es: "Transforma tu" },
  "lp.pk.title_grad": { it: "posto auto", en: "parking spot", fr: "place de parking", de: "Parkplatz", es: "plaza de aparcamiento" },
  "lp.pk.title_2": { it: "senza commissioni", en: "into income", fr: "en revenu", de: "in Einkommen", es: "en ingresos" },
  "lp.pk.sub": { it: "Hai un garage inutilizzato, un box, un posto scoperto o un giardino? Crea la pagina del tuo parcheggio, ricevi contatti diretti e guadagna. Prima registrazione gratuita, poi solo €4,99/anno.", en: "Got an unused garage, box, open spot or garden? Create your parking page, get direct contacts and earn. First registration free, then just €4.99/year.", fr: "Vous avez un garage inutilisé, un box, une place découverte ou un jardin ? Créez la page de votre parking, recevez des contacts directs et gagnez. Première inscription gratuite, puis seulement 4,99 €/an.", de: "Hast du eine ungenutzte Garage, einen Box, einen offenen Parkplatz oder einen Garten? Erstelle die Seite deines Parkplatzes, erhalte direkte Kontakte und verdiene. Erste Anmeldung kostenlos, dann nur 4,99 €/Jahr.", es: "¿Tienes un garaje sin usar, un box, una plaza descubierta o un jardín? Crea la página de tu aparcamiento, recibe contactos directos y gana. Primera inscripción gratis, luego solo 4,99 €/año." },
  "lp.pk.cta": { it: "Diventa ParkHost", en: "Become a ParkHost", fr: "Devenir ParkHost", de: "ParkHost werden", es: "Hazte ParkHost" },

  // Property sliders
  "lp.slider.trending_eye": { it: "Le più cliccate", en: "Most clicked", fr: "Les plus cliquées", de: "Am meisten angeklickt", es: "Más clicadas" },
  "lp.slider.trending_title": { it: "Case vacanze e B&B su Hostland", en: "Trending properties", fr: "Propriétés tendance", de: "Trending-Unterkünfte", es: "Alojamientos en tendencia" },
  "lp.slider.trending_sub": { it: "Ordine basato sulle visualizzazioni · nessun algoritmo nascosto", en: "Ordered by views · no hidden algorithm", fr: "Trié par vues · aucun algorithme caché", de: "Nach Aufrufen sortiert · kein versteckter Algorithmus", es: "Ordenado por visualizaciones · sin algoritmo oculto" },
  "lp.slider.latest_eye": { it: "★ Nuovi arrivi", en: "★ New arrivals", fr: "★ Nouveautés", de: "★ Neuzugänge", es: "★ Novedades" },
  "lp.slider.latest_title": { it: "Appena aggiunte", en: "Just added", fr: "Ajoutés récemment", de: "Neu hinzugefügt", es: "Recién añadidas" },
  "lp.slider.latest_sub": { it: "Le ultime 20 strutture registrate su Hostland", en: "The last 20 properties registered on Hostland", fr: "Les 20 dernières propriétés enregistrées sur Hostland", de: "Die letzten 20 Unterkünfte auf Hostland", es: "Los últimos 20 alojamientos registrados en Hostland" },
  "lp.slider.see_all": { it: "Vedi tutte", en: "See all", fr: "Voir tout", de: "Alle ansehen", es: "Ver todas" },
  "lp.slider.map": { it: "Esplora mappa", en: "Explore map", fr: "Explorer la carte", de: "Karte erkunden", es: "Explorar mapa" },

  // Events
  "lp.events.eye": { it: "✨ Eventi in Italia", en: "✨ Events in Italy", fr: "✨ Événements en Italie", de: "✨ Events in Italien", es: "✨ Eventos en Italia" },
  "lp.events.title": { it: "Cosa succede nelle nostre città", en: "What's happening in our cities", fr: "Ce qui se passe dans nos villes", de: "Was in unseren Städten passiert", es: "Qué está pasando en nuestras ciudades" },

  // How it works
  "lp.how.eye": { it: "Come funziona", en: "How it works", fr: "Comment ça marche", de: "So funktioniert's", es: "Cómo funciona" },
  "lp.how.title": { it: "Sei passaggi per disintermediare", en: "Six steps to disintermediate", fr: "Six étapes pour désintermédier", de: "Sechs Schritte zur Disintermediation", es: "Seis pasos para desintermediar" },
  "lp.how.sub": { it: "Trasforma la tua struttura in un'esperienza professionale che genera prenotazioni dirette", en: "Turn your property into a professional experience that drives direct bookings", fr: "Transformez votre logement en expérience professionnelle générant des réservations directes", de: "Verwandle deine Unterkunft in ein professionelles Erlebnis, das Direktbuchungen generiert", es: "Transforma tu alojamiento en una experiencia profesional que genera reservas directas" },

  // Pricing
  "lp.price.eye": { it: "Prezzi", en: "Pricing", fr: "Tarifs", de: "Preise", es: "Precios" },
  "lp.price.title": { it: "Semplici. Trasparenti.", en: "Simple. Transparent.", fr: "Simples. Transparents.", de: "Einfach. Transparent.", es: "Simples. Transparentes." },
  "lp.price.sub": { it: "30 giorni gratuiti, pagamenti gestiti da Stripe®. Cancella quando vuoi.", en: "30 days free, payments handled by Stripe®. Cancel anytime.", fr: "30 jours gratuits, paiements via Stripe®. Annulation à tout moment.", de: "30 Tage gratis, Zahlungen über Stripe®. Jederzeit kündbar.", es: "30 días gratis, pagos gestionados por Stripe®. Cancela cuando quieras." },
  "lp.price.trial": { it: "Prova gratuita", en: "Free trial", fr: "Essai gratuit", de: "Kostenlose Testphase", es: "Prueba gratuita" },
  "lp.price.trial_price": { it: "/30gg", en: "/30d", fr: "/30j", de: "/30T", es: "/30d" },
  "lp.price.trial_note": { it: "Nessuna carta richiesta", en: "No card required", fr: "Aucune carte requise", de: "Keine Karte erforderlich", es: "No se requiere tarjeta" },
  "lp.price.monthly": { it: "Mensile", en: "Monthly", fr: "Mensuel", de: "Monatlich", es: "Mensual" },
  "lp.price.monthly_per": { it: "/mese", en: "/month", fr: "/mois", de: "/Monat", es: "/mes" },
  "lp.price.monthly_note": { it: "Meno di un caffè a settimana", en: "Less than a coffee per week", fr: "Moins d'un café par semaine", de: "Weniger als ein Kaffee pro Woche", es: "Menos que un café a la semana" },
  "lp.price.yearly": { it: "Annuale · Consigliato", en: "Yearly · Recommended", fr: "Annuel · Recommandé", de: "Jährlich · Empfohlen", es: "Anual · Recomendado" },
  "lp.price.yearly_per": { it: "/anno", en: "/year", fr: "/an", de: "/Jahr", es: "/año" },
  "lp.price.yearly_note": { it: "Solo €4,99/mese", en: "Only €4.99/month", fr: "Seulement 4,99 €/mois", de: "Nur 4,99 €/Monat", es: "Solo 4,99 €/mes" },
  "lp.price.badge_save": { it: "RISPARMIA 50%", en: "SAVE 50%", fr: "ÉCONOMISEZ 50%", de: "SPARE 50%", es: "AHORRA 50%" },
  "lp.price.start_now": { it: "Inizia ora", en: "Start now", fr: "Commencer", de: "Jetzt starten", es: "Empezar ahora" },
  "lp.price.activate_m": { it: "Attiva mensile", en: "Activate monthly", fr: "Activer mensuel", de: "Monatlich aktivieren", es: "Activar mensual" },
  "lp.price.activate_y": { it: "Attiva annuale", en: "Activate yearly", fr: "Activer annuel", de: "Jährlich aktivieren", es: "Activar anual" },
  "lp.price.per_extra": { it: "Ogni casa in più: €1 una tantum", en: "Each extra property: €1 one-off", fr: "Chaque logement supplémentaire : 1 € unique", de: "Jede zusätzliche Unterkunft: 1 € einmalig", es: "Cada alojamiento extra: 1 € único" },
  "lp.price.pk_title": { it: "ParkHost — €4,99/anno", en: "ParkHost — €4.99/year", fr: "ParkHost — 4,99 €/an", de: "ParkHost — 4,99 €/Jahr", es: "ParkHost — 4,99 €/año" },
  "lp.price.pk_sub": { it: "Un mese gratis · poi €4,99/anno per pubblicare il tuo posto auto", en: "One month free · then €4.99/year to publish your parking spot", fr: "Un mois gratuit · puis 4,99 €/an pour publier votre place", de: "Ein Monat gratis · dann 4,99 €/Jahr für deinen Parkplatz", es: "Un mes gratis · luego 4,99 €/año para publicar tu plaza" },
  "lp.price.pk_join": { it: "Iscriviti", en: "Join", fr: "Rejoindre", de: "Beitreten", es: "Únete" },

  // FAQ
  "lp.faq.eye": { it: "FAQ", en: "FAQ", fr: "FAQ", de: "FAQ", es: "FAQ" },
  "lp.faq.title": { it: "Domande frequenti su Hostland", en: "All clear?", fr: "Tout est clair ?", de: "Alles klar?", es: "¿Todo claro?" },
  "lp.faq.sub": { it: "Le risposte alle domande più frequenti di host, PM e viaggiatori", en: "Answers to the most common questions from hosts, PMs and travelers", fr: "Les réponses aux questions fréquentes des hôtes, PM et voyageurs", de: "Antworten auf die häufigsten Fragen von Hosts, PMs und Reisenden", es: "Respuestas a las preguntas más frecuentes de hosts, PMs y viajeros" },

  // Final CTA
  "lp.final.eye": { it: "Prova gratis 30 giorni", en: "Free 30-day trial", fr: "Essai gratuit 30 jours", de: "Kostenlose 30-Tage-Testphase", es: "Prueba gratuita 30 días" },
  "lp.final.title": { it: "Il sito, il Welcome Book Digitale, il QR.", en: "The site, the digital Welcome Book, the QR.", fr: "Le site, le Welcome Book Numérique, le QR.", de: "Die Website, das digitale Welcome Book, der QR.", es: "El sitio, el Welcome Book Digital, el QR." },
  "lp.final.sub": { it: "Landing page, GuestBook multilingua, QR code premium, recensioni Google — tutto incluso, pagamenti sicuri via Stripe®.", en: "Landing page, multilingual GuestBook, premium QR code, Google reviews — all included, secure payments via Stripe®.", fr: "Landing page, GuestBook multilingue, code QR premium, avis Google — tout inclus, paiements sécurisés via Stripe®.", de: "Landingpage, mehrsprachiges GuestBook, Premium-QR-Code, Google-Bewertungen — alles inklusive, sichere Zahlungen über Stripe®.", es: "Landing page, GuestBook multilingüe, código QR premium, reseñas Google — todo incluido, pagos seguros vía Stripe®." },
  "lp.final.cta": { it: "Inizia gratis ora", en: "Start free now", fr: "Commencer gratuit", de: "Jetzt kostenlos starten", es: "Empieza gratis ahora" },
};

export default translations;
